import { FC, ReactNode } from 'react'
import { cn } from 'utilities/StringUtils'

interface Props {
  children?: ReactNode
  className?: string
  withPadding?: boolean
}

export const Card: FC<Props> = ({ children, withPadding = true, className }) => (
  <div
    className={cn(
      'text-sm rounded-lg transition-colors bg-background border border-border shadow-sm space-y-2',
      { 'p-6': withPadding },
      className
    )}
  >
    {children}
  </div>
)
